import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=fd17a292&scoped=true&"
import script from "./Sponsorship.vue?vue&type=script&lang=js&"
export * from "./Sponsorship.vue?vue&type=script&lang=js&"
import style0 from "./Sponsorship.vue?vue&type=style&index=0&id=fd17a292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd17a292",
  null
  
)

export default component.exports